import { useSelector } from 'react-redux';

import { DailyrentNewReviewModalContentContainer } from '../DailyrentNewReviewModalContent';
import { DailyrentNewReviewAccessRejection } from '../../components/DailyrentNewReviewAccessRejection';
import { useDailyrentNewReviewModal } from './hooks/useDailyrentNewReviewModal';
import { NewReviewContext } from '../../utils/newReview/context';
import { useApplicationContext } from '../../utils/applicationContext';
import { getObjectId } from '../../selectors/objectInfo';

export function DailyrentNewReviewModalContainer() {
  const { custom } = useApplicationContext();
  const objectId = useSelector(getObjectId);
  const params = useDailyrentNewReviewModal();
  const { isOpened, onClose, rejectAccessError, onBookClick, requestAuth, handleReload } = params;

  if (rejectAccessError) {
    return (
      <DailyrentNewReviewAccessRejection
        isOpened={isOpened}
        onClose={onClose}
        deviceType={custom.deviceType}
        objectId={objectId}
        errorCode={rejectAccessError}
        onBookClick={onBookClick}
        onRequestAuth={requestAuth}
        onReload={handleReload}
      />
    );
  }

  return (
    <NewReviewContext.Provider value={params}>
      <DailyrentNewReviewModalContentContainer onClose={onClose} />
    </NewReviewContext.Provider>
  );
}
